import { component } from 'flightjs';
import cookieUtil from 'tradera/utils/cookie';

function SignupReferralPathCookieCreator() {
    var cookieName = 'signup_referral_path';

    var setCookie = function (value) {
        var expireDate = new Date();
        expireDate.setTime(expireDate.getTime() + 10 * 60 * 1000);
        cookieUtil.createCookie(cookieName, value, expireDate);
    };

    this.createSignupReferralPathCookie = function () {
        var referralPath = window.location.href;
        setCookie(referralPath);
    };

    this.after('initialize', function () {
        this.on('click', this.createSignupReferralPathCookie);
    });
}

export default component(SignupReferralPathCookieCreator);
